import { Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { RootState } from '../../../../reducers';
import { setDevices } from '../../../../store/memberDetail.slice';

const TelemonitoringDeviceRow = (params: any) => {
    const dispatch = useAppDispatch();
    const { devices } = useSelector((state: RootState) => state.memberDetail);

    const changeHasDevice = (event, checked) => {
        const newItem = { ...devices };
        for (let prop in newItem) {
            if (newItem[prop]?.Name === params.device.Name) {
                let update = { ...newItem[prop] };
                update.HasDevice = checked;

                newItem[prop] = update;
            }
        }
        dispatch(setDevices(newItem));
    };

    const changeSerialNumber = (event, value) => {
        const newItem = { ...devices };
        for (let prop in newItem) {
            if (newItem[prop]?.Name === params.device.Name) {
                let update = { ...newItem[prop] };
                update.SerialNumber = value;

                newItem[prop] = update;
            }
        }
        dispatch(setDevices(newItem));
    };

    const changeDeliveryDate = (newDate) => {
        const newItem = { ...devices };
        for (let prop in newItem) {
            if (newItem[prop]?.Name === params.device.Name) {
                let update = { ...newItem[prop] };
                update.DeliveryDate = newDate;

                newItem[prop] = update;
            }
        }
        dispatch(setDevices(newItem));
    };

    const changeRetrievalDate = (newDate) => {
        const newItem = { ...devices };
        for (let prop in newItem) {
            if (newItem[prop]?.Name === params.device.Name) {
                let update = { ...newItem[prop] };
                update.RetrievalDate = newDate;

                newItem[prop] = update;
            }
        }
        dispatch(setDevices(newItem));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container spacing={2} style={{ textAlign: 'left', marginBottom: '32px' }}>
                <Grid size={12 / 5}>
                    <Typography>{params.device.Name}</Typography>
                </Grid>
                <Grid size={12 / 5}>
                    <FormControlLabel
                        control={<Checkbox checked={params.device.HasDevice} />}
                        onChange={(e: any) => changeHasDevice(e, e.target.checked)}
                        label="Has Device"
                    />
                </Grid>
                <Grid size={12 / 5}>
                    <DatePicker
                        label="Delivery Date"
                        slotProps={{ textField: { sx: { width: '100%' } } }}
                        onChange={(e: any) => {
                            changeDeliveryDate(e);
                        }}
                        value={params.device.DeliveryDate ? new Date(params.device.DeliveryDate) : null}
                    />
                </Grid>
                <Grid size={12 / 5}>
                    <DatePicker
                        label="Retrieval Date"
                        slotProps={{ textField: { sx: { width: '100%' } } }}
                        onChange={(e: any) => {
                            changeRetrievalDate(e);
                        }}
                        value={params.device.RetrievalDate ? new Date(params.device.RetrievalDate) : null}
                    />
                </Grid>
                <Grid size={12 / 5}>
                    <TextField
                        id="outlined-basic"
                        fullWidth
                        label="Serial Number"
                        variant="outlined"
                        value={params.device.SerialNumber}
                        onChange={(e: any) => {
                            changeSerialNumber(e, e.target.value);
                        }}
                    />
                </Grid>
            </Grid>
        </LocalizationProvider>
    );
};

export default TelemonitoringDeviceRow;
